module.exports = __webpack_public_path__ + "img/enviroom1.64cf1408.jpg";